import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DatasharesIntegrationsListForNro = lazy(() =>
  import("@scenes/DatasharesIntegrationsList/DatasharesIntegrationsListForNro").then((module) => ({
    default: module.DatasharesIntegrationsListForNro,
  }))
);

export const datasharesIntegrationsNRO: NavigationRoutingObject = {
  Component: DatasharesIntegrationsListForNro,
  componentFeatureFlippers: ["datashares_integrations", "datashares_integrations_nro_component"],
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">, { featureOn }) =>
    featureOn("delta_sharing_beta")
      ? t("direct-data-sharing-label", "Direct Data Sharing")
      : t("datashares-sidebar-pill-menu-option", "Data Sharing"),
  pageNameForTracking: ({ featureOn }) =>
    featureOn("delta_sharing_beta") ? "Direct Data Sharing" : "Data Sharing",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "datashares-description-nav",
      "Instantly share new and historical Braze event data to your Snowflake account"
    ),
  icon: "nav-system-data-sharing",
  featureLimitationKeys: ["can_only_view_landing_page_data_sharing"],
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("datashares_integrations");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("datashares-alt-keyword-1", "datashare integrations")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/datashares_integrations/:appGroupId",
};
